import React, { useState } from 'react';
import { useAuth } from '../../AuthContext';
import './PracticeSurveys.css';

function ChinaSurvey() {
  const [answers, setAnswers] = useState({});
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const { userDetails } = useAuth(); // Use userDetails from AuthContext
  const apiUrl = process.env.REACT_APP_API_BASE_URL;


  // Function to handle input change for each question
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAnswers(prevAnswers => ({
      ...prevAnswers,
      [name]: value
    }));
  };

  // Function to handle moving to the next question
  const handleNextQuestion = () => {
    setCurrentQuestion(prevQuestion => prevQuestion + 1);
  };

  // Function to handle moving to the previous question
  const handlePreviousQuestion = () => {
    setCurrentQuestion(prevQuestion => prevQuestion - 1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const finalScore = calculateScore(answers);
    setSubmitted(true);

    // Ensure that the user is logged in before allowing score submission
    if (!userDetails.email) {
      alert("You must be logged in to submit scores.");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/submit-score`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: userDetails.email, // Use email for score submission
          score: finalScore,
          surveyId: 'ChinaSurvey',
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit score');
      }

      alert('Score submitted successfully!');
    } catch (error) {
      console.error('Score submission error:', error);
      alert(error.message);
    }
  };
  const calculateScore = (answers) => {
    let score = 0;
    questions.forEach(question => {
      if (answers[question.id] === question.correctAnswer) {
        score += 10;  // Assuming each correct answer gives 10 points
      }
    });
    return score;
  };

  // Questions data for China
  const questions = [
    {
      id: 'continent',
      label: 'In which continent is China located?',
      correctAnswer: 'Asia',
      options: ['Asia', 'Europe', 'North America', 'South America', 'Africa']
    },
    {
      id: 'population',
      label: 'What is the population of China?',
      correctAnswer: 'Around 1.4 Billion',
      options: ['Around 500 Million', 'Around 800 Million', 'Around 1 Billion', 'Around 1.4 Billion', 'Around 2 Billion']
    },
    {
      id: 'totalArea',
      label: 'What is the total area of the country?',
      correctAnswer: '9.6 million square kilometers',
      options: ['5 million square kilometers', '7.5 million square kilometers', '9.6 million square kilometers', '11 million square kilometers', '13 million square kilometers']
    },
    {
      id: 'capital',
      label: 'What is the capital of China?',
      correctAnswer: 'Beijing',
      options: ['Shanghai', 'Hong Kong', 'Beijing', 'Guangzhou', 'Shenzhen']
    },
    {
      id: 'governor',
      label: 'Who is the current governor of China?',
      correctAnswer: 'Xi Jinping',
      options: ['Xi Jinping', 'Hu Jintao', 'Deng Xiaoping', 'Mao Zedong', 'Li Keqiang']
    },
    {
      id: 'largestCountryPosition',
      label: 'What position does China occupy as the largest country in the world?',
      correctAnswer: '4th',
      options: ['1st', '2nd', '3rd', '4th', '5th']
    },
    {
      id: 'popularRivers',
      label: 'What are the most popular rivers of China?',
      correctAnswer: 'Yangtze River and Yellow River',
      options: ['Nile River and Amazon River', 'Yangtze River and Yellow River', 'Mississippi River and Congo River', 'Ganges River and Mekong River', 'Danube River and Indus River']
    },
    {
      id: 'yangtzeRiverPosition',
      label: 'What positions does the Yangtze River occupy as the largest river in the world?',
      correctAnswer: '3rd',
      options: ['1st', '2nd', '3rd', '4th', '5th']
    },
    {
      id: 'regions',
      label: 'How many regions divide the country?',
      correctAnswer: '33 regions',
      options: ['20 regions', '25 regions', '30 regions', '33 regions', '40 regions']
    },
    {
      id: 'secondLargestEconomy',
      label: 'Does China have the second largest economy in the world?',
      correctAnswer: 'Yes',
      options: ['Yes', 'No']
    },
    {
      id: 'renownedDynasties',
      label: 'What are the most renowned dynasties in China?',
      correctAnswer: 'Xia and Qin Dynasty',
      options: ['Shang and Tang Dynasty', 'Ming and Qing Dynasty', 'Han and Song Dynasty', 'Xia and Qin Dynasty', 'Yuan and Ming Dynasty']
    },
    {
      id: 'importantInventions',
      label: 'What are some of the most important inventions made by China?',
      correctAnswer: 'Paper, Magnetic Compass and Printing',
      options: ['Gunpowder, Paper and Printing', 'Compass, Paper and Gunpowder', 'Printing, Compass and Silk', 'Paper, Magnetic Compass and Printing', 'Printing, Gunpowder and Silk']
    },
    {
      id: 'touristPlace',
      label: 'What is the name of the most touristic place in the country?',
      correctAnswer: 'Great Wall of China',
      options: ['Forbidden City', 'Terracotta Army', 'Potala Palace', 'Great Wall of China', 'Mount Everest']
    },
    {
      id: 'ancientCivilization',
      label: 'China is home to one of the world\'s most ancient civilizations?',
      correctAnswer: 'True',
      options: ['True', 'False']
    }
  ];

  return (
    <div className="container">
      {!submitted && (
        <div className="card mt-4">
          <div className="surveycard">
            <h2>China Survey</h2>
          </div>
        </div>
      )}
      {!submitted && (
        <div className="card mt-4">
          <div className="surveycard">
            <form onSubmit={handleSubmit}>
              {/* Display current question */}
              <div>
                <div className="surveyform">
                  <label htmlFor={questions[currentQuestion].id}>{questions[currentQuestion].label}</label>
                  <select
                    className="surveyformcontrol"
                    id={questions[currentQuestion].id}
                    name={questions[currentQuestion].id}
                    value={answers[questions[currentQuestion].id]}
                    onChange={handleInputChange}
                  >
                    <option value="">Select an option</option>
                    {questions[currentQuestion].options.map((option, index) => (
                      <option key={index} value={option}>{option}</option>
                    ))}
                  </select>
                </div>
                {/* Hide buttons after form submission */}
                {!submitted && (
                  <div>
                    {/* Next and Previous buttons */}
                    {currentQuestion > 0 && <button type="button" className="surveybuttons" onClick={handlePreviousQuestion}>Previous</button>}
                    {currentQuestion < questions.length - 1 && <button type="button" className="surveybuttons" onClick={handleNextQuestion}>Next</button>}
                    {currentQuestion === questions.length - 1 && <button type="submit" className="surveybuttons">Submit</button>}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Display answers after form submission */}
      {submitted && (
        <div className="card mt-4">
          <div className="surveycard">
            <h3 className="surveyanswers">Answers:</h3>
            {questions.map(question => (
              <div key={question.id}>
                <p><strong>{question.label}</strong></p>
                <p>Your answer: {answers[question.id]}</p>
                <p>Correct answer: {question.correctAnswer}</p>
                {/* Add logic here to compare user's answer with correct answer and style accordingly */}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ChinaSurvey;
